import React from 'react';
import { InfoAlert } from 'components/styles_components/alert';

const InfoContainer = ({
  visible = false,
  action = null,
  icon = null,
  color = null,
  severity = 'info',
  children,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <InfoAlert icon={icon} color={color} action={action} severity={severity}>
      {children}
    </InfoAlert>
  );
};

export default InfoContainer;
